import MarkdownEditor from "@/component/Markdown/MarkdownEditor";
import MarkdownPreview from "@/component/Markdown/MarkdownPreview";
import MarkdownRenderer from "@/component/Markdown/MarkdownRenderer";
import summaryStore from "@/store/summary.store";
import summaryCommonStore from "@/store/summaryCommon.store";
import summarySrcStore from "@/store/summarySrc.store";
import formatMarkdown from "@/utils/formatMarkdown";

const MeetingContent = () => {
  const summaryEditing = summaryCommonStore((state) => state.summaryEditing);
  const summary = summaryStore((state) => state.summary);
  const newSummary = summaryStore((state) => state.newSummary);
  const modifySummary = summaryStore((state) => state.modifySummary);
  const detailInfo = summarySrcStore((state) => state.detailInfo);
  const showBackTraceEnter = summaryCommonStore(
    (state) => state.showBackTraceEnter
  );

  const newContent = formatMarkdown(
    newSummary?.content,
    detailInfo?.useMarkDownSummary,
    showBackTraceEnter && !summaryEditing
  );
  const originContent = formatMarkdown(
    summary?.srcAiGcContent?.content,
    detailInfo?.useMarkDownSummary,
    showBackTraceEnter && !summaryEditing
  );

  const onChange = (value: string) => {
    // 保存
    if (!newSummary) return;
    console.log("onChange", value);
    modifySummary({
      ...newSummary,
      content: value.split("\n"),
    });
  };


  return (
    <div className="relative color-#30343C text-3.5 font-normal text-justify select-text lh-7">
      {summaryEditing ? (
        <MarkdownEditor
          mode="wysiwyg"
          initialValue={newContent}
          onChange={onChange}
        />
      ) : originContent !== "" ? (
        <>
          <MarkdownPreview className="hidden" value={originContent} />
          <MarkdownRenderer content={originContent || ""} />
        </>
      ) : (
        <div className="text-mx-quaternary">暂无内容哦</div>
      )}
    </div>
  );
};

export default MeetingContent;
